/**
 * Lista preimpostata dei principali concessionari italiani retail (ADM).
 * I loghi sono PNG caricati dall'utente in /app/frontend/public/brands/.
 *
 * Il valore `id` viene salvato sull'agency (`brand_concessionario`) ed è
 * usato come chiave stabile anche se in futuro cambia label/logo.
 *
 * Convenzioni file:
 *   - {id}.png          → wordmark/logo principale (usato in dashboard)
 *   - {id}-glyph.png    → glifo quadrato 64x64 (usato in switcher e dropdown)
 */
export const CONCESSIONARI = [
    { id: "snai", name: "SNAI", color: "#FF6B00", logo: "/brands/snai.png", glyph: "/brands/snai-glyph.png" },
    { id: "sisal_matchpoint", name: "Sisal Matchpoint", color: "#015E3E", logo: "/brands/sisal.png", glyph: "/brands/sisal-glyph.png" },
    { id: "lottomatica", name: "Lottomatica", color: "#003594", logo: "/brands/lottomatica.png", glyph: "/brands/lottomatica-glyph.png" },
    { id: "eurobet", name: "Eurobet", color: "#243561", logo: "/brands/eurobet.png", glyph: "/brands/eurobet-glyph.png" },
    { id: "goldbet", name: "Goldbet", color: "#FFCC01", logo: "/brands/goldbet.png", glyph: "/brands/goldbet-glyph.png" },
    { id: "planetwin365", name: "Planetwin365", color: "#FAB616", logo: "/brands/planetwin365.png", glyph: "/brands/planetwin365-glyph.png" },
    { id: "stanleybet", name: "Stanleybet", color: "#CC0100", logo: "/brands/stanleybet.png", glyph: "/brands/stanleybet-glyph.png" },
    { id: "admiral", name: "Admiral", color: "#002454", logo: "/brands/admiral.png", glyph: "/brands/admiral-glyph.png" },
    { id: "bet365", name: "Bet365", color: "#15523F", logo: "/brands/bet365.png", glyph: "/brands/bet365-glyph.png" },
    { id: "betflag", name: "Betflag", color: "#002742", logo: "/brands/betflag.png", glyph: "/brands/betflag-glyph.png" },
];

export const CUSTOM_BRAND = { id: "custom", name: "Personalizzato / Altro", color: "#71717a", logo: null, glyph: null };

export function findConcessionario(id) {
    if (!id || id === "custom") return null;
    return CONCESSIONARI.find((c) => c.id === id) || null;
}
